<template>
  <div class="home">
    <el-container>
      <!-- 头部 -->
      <el-header style="padding:0;margin:0">
        <toubu></toubu>
      </el-header>
      <!-- 中间内容 -->
      <el-main style="padding:0px;margin-top:22px;padding-bottom:0px">
        <div>
          <router-view></router-view>
        </div>
      </el-main>
      <!-- 底部 -->
      <el-footer style="padding:0;margin:0">
        <Footer></Footer>
      </el-footer>
    </el-container>
  </div>
</template>

<script>

import Footer from '../components/Footer.vue'
import toubu from '../components/toubu.vue'
export default {
  data () {
    return {
      tableData: [{
        date: '2016-05-02',
        name: '王小虎',

      }, {
        date: '2016-05-04',
        name: '王小虎',

      }, {
        date: '2016-05-01',
        name: '王小虎',

      }, {
        date: '2016-05-03',
        name: '王小虎',

      }]
    }
  },
  components: {
    Footer,
    toubu
  }
}
</script>

<style lang="scss" scoped>
.home {
  background-color: black;
  width: 100%;
  height: 100%;
}

// 底部

.button {
  // position: relative;
  // left: 45px;
  // top: 63px;
  width: 100%;
  background-color: rgb(51, 51, 51);
  margin-top: 100px;
  margin-left: 45px;
}
</style>
